import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  class: "item-caret"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = {
  key: 0,
  class: "item-exterior"
}
const _hoisted_4 = { class: "item-desc" }
const _hoisted_5 = { class: "desc-type" }
const _hoisted_6 = { class: "desc-name" }
const _hoisted_7 = { class: "item-price" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemIcon = _resolveComponent("ItemIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "cart-item",
    style: _normalizeStyle({ '--color': _ctx.color })
  }, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "item-bg" }, null, -1)),
    (_openBlock(), _createElementBlock("svg", _hoisted_1, [
      _createElementVNode("path", {
        d: "M4 12C1.79086 12 -6.7098e-08 10.2091 -1.49868e-07 8L-4.49603e-07 9.53674e-07L6 6L12 12L4 12Z",
        fill: _ctx.color
      }, null, 8, _hoisted_2)
    ])),
    (_ctx.exterior)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.exteriorNormalized), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_ItemIcon, {
      icon: _ctx.icon,
      size: 120,
      zoom: _ctx.zoom,
      class: "item-icon"
    }, null, 8, ["icon", "zoom"]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.typeNormalized), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.name), 1)
    ]),
    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.priceNormalized), 1),
    (_openBlock(), _createElementBlock("svg", {
      width: "8",
      height: "8",
      viewBox: "0 0 8 8",
      fill: "none",
      class: "item-remove",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args)))
    }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("g", { opacity: "0.5" }, [
        _createElementVNode("path", {
          d: "M7 1L1 7",
          stroke: "white",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }),
        _createElementVNode("path", {
          d: "M1 1L7 7",
          stroke: "white",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1)
    ]))]))
  ], 4))
}